<template>
  <div>
    <h4>redirecting...</h4>
  </div>
</template>
<script>
import accountApi from "@/api/account";
import advertApi from "@/api/advert";
import store from "@/store";

export default {
    data() {
        return {
        }
    },
    created() {
      accountApi.ssoEcTokenKey(data => {
        if(data.key && data.url) {
          window.location.href = data.url + '?key=' + data.key;
        } else if (data.url && !data.key){
          window.location.href = data.url;
        } else {
          advertApi.homeCompanyUrl(store.getters['advancedSearch/companyId'], data => {
            window.location.href = data;
          })
        }
      });
    }
}
</script>

<style lang="scss" scoped>
h4 {
  color: #1d1f20;
}
</style>
